import { USStates } from "helpers/us-states";
import React, { useState, useRef } from "react";
import "./style.scss";

type Props = {
  city: string;
  state: string;
  isAllowed: boolean;
  updateCity: (val: string) => void;
  updateState: (val: string) => void;
};

export const ProfileCityState: React.FC<Props> = ({
  city,
  state,
  isAllowed,
  updateCity,
  updateState,
}) => {
  return (
    <div className="profile-input-container">
      <span>City / State</span>
			<div style={{display: "flex", flex: 1, alignItems: "center"}}>
				<div className={isAllowed ? 'profile-input2' : 'profile-input2 profile-input2-disabled'}>
					<input
						value={city != null ? city : ""}
						type="text"
						disabled={!isAllowed}
						onChange={(e) => updateCity(e.target.value)}
					></input>
				</div>
				<div style={{ width: "20px"}}></div>
				<div className={isAllowed ? 'advance-select' : 'advance-select advance-select-disabled'}>
					<select
						value={state}
						onChange={(e: any) => updateState(e.target.value)}
						disabled={!isAllowed}
					>
						{USStates.map((s, index) => (
							<React.Fragment key={`city-${index}`}>
								<option value="Unknown">Unknown</option>
								<option value={s.abbreviation}>{s.name}</option>
							</React.Fragment>
						))}
					</select>
				</div>
			</div>
    </div>
  );
};
